<main class="error-page-content">
  <i class="m-icon network-check error-page-icon"></i>
  <h1 class="error-page-title" [innerHTML]="getTitle()"></h1>
  <p class="error-page-text" [innerHTML]="getText()"></p>
  <a class="btn btn-primary error-page-button" routerLink=""><i class="m-icon arrow-forward"></i> {{getButtonText()}}</a>
</main>
